// Club pause policy display (pause_payments_modal.vue and its mock in self_pause_settings.vue).
// A policy taller than this collapses to a preview behind a "Read the full policy" toggle, so a
// long policy never pushes the pause controls off screen. Must match
// .pause-modal__policy-body.is-collapsed in subscriptions.scss.
export const POLICY_COLLAPSED_HEIGHT = 120;

// Whether the rendered policy is enough taller than the collapsed height to be worth clamping.
// A little slack avoids a toggle that reveals a single extra line.
export function policyOverflows(el, collapsedHeight) {
  return !!el && el.scrollHeight > collapsedHeight + 32;
}
